var map = {
	"./_settings.scss": 798,
	"./base/_alert-boxes.scss": 799,
	"./base/_badges.scss": 800,
	"./base/_base.scss": 801,
	"./base/_cw-footer.scss": 802,
	"./base/_fonts.scss": 803,
	"./base/_forms.scss": 804,
	"./base/_grid.scss": 805,
	"./base/_layout.scss": 806,
	"./base/_lightbox.scss": 807,
	"./base/_modal.scss": 808,
	"./base/_nav-bar.scss": 809,
	"./base/_normal_font.scss": 290,
	"./base/_offcanvas.scss": 810,
	"./base/_pagination.scss": 811,
	"./base/_panels.scss": 812,
	"./base/_sharing.scss": 813,
	"./base/_switches.scss": 814,
	"./base/_tables.scss": 815,
	"./base/_tooltips.scss": 816,
	"./base/_type.scss": 817,
	"./base/_video.scss": 818,
	"./base/_visibility.scss": 819,
	"./base/buttons/_all.scss": 820,
	"./base/buttons/_mixins.scss": 821,
	"./base/buttons/_sharing.scss": 822,
	"./base/forms/_checkboxes.scss": 823,
	"./base/forms/_input-combos.scss": 824,
	"./base/forms/_non-text.scss": 825,
	"./base/forms/_text-fields.scss": 826,
	"./base/nav-bar/_base-with-links.scss": 827,
	"./base/nav-bar/_base.scss": 828,
	"./base/nav-bar/_fade.scss": 829,
	"./base/nav-bar/_inverted.scss": 830,
	"./base/nav-bar/_large-up.scss": 831,
	"./pages/accounts.scss": 832,
	"./pages/admin.scss": 833,
	"./pages/admin/offline_donations.scss": 834,
	"./pages/authorization.scss": 835,
	"./pages/birthdays.scss": 836,
	"./pages/campaigns.scss": 837,
	"./pages/charityball.scss": 838,
	"./pages/donations.scss": 839,
	"./pages/donations/_donate-form.scss": 840,
	"./pages/donations/_generic-right-side-donate.scss": 841,
	"./pages/donations/_hidden-campaign.scss": 842,
	"./pages/donations/_sponsor-recognition.scss": 843,
	"./pages/donations/_thank-you.scss": 844,
	"./pages/donations/components/_ach-popout-form.scss": 845,
	"./pages/donations/components/_apple-pay-button.scss": 846,
	"./pages/donations/components/_browser-fallback.scss": 847,
	"./pages/donations/components/_donate-buttons.scss": 848,
	"./pages/donations/components/_donate-by-check-modal.scss": 849,
	"./pages/donations/components/_donation-form-inputs.scss": 850,
	"./pages/donations/components/_gift_aid.scss": 851,
	"./pages/donations/components/_iho.scss": 852,
	"./pages/donations/components/_offscreen-donate-components.scss": 853,
	"./pages/donations/components/_stripe-elements.scss": 854,
	"./pages/donations/direct.scss": 855,
	"./pages/donations/general.scss": 856,
	"./pages/donations/gift-the-spring.scss": 857,
	"./pages/donations/in-honor-of.scss": 858,
	"./pages/donations/sponsor.scss": 859,
	"./pages/donations/the-spring-new.scss": 860,
	"./pages/donations/thespring.scss": 861,
	"./pages/donations/user.scss": 862,
	"./pages/edit_mailing_list_subscriber.scss": 863,
	"./pages/exceptions.scss": 864,
	"./pages/founders.scss": 865,
	"./pages/mailing-list-subscribers.scss": 866,
	"./pages/premium_impact_profile.scss": 867,
	"./pages/profile/bps_membership.scss": 868,
	"./pages/profile/my_projects.scss": 869,
	"./pages/profile/shared.scss": 870,
	"./pages/profile/spring_membership.scss": 871,
	"./pages/profile/user_private.scss": 872,
	"./pages/profile/user_public.scss": 873,
	"./pages/projects/_country_icons.scss": 874,
	"./pages/projects/projects.scss": 875,
	"./pages/redeem-the-spring.scss": 876,
	"./pages/search.scss": 877,
	"./pages/static_pages/about.scss": 878,
	"./pages/static_pages/brand_partnerships.scss": 879,
	"./pages/static_pages/company_match.scss": 880,
	"./pages/static_pages/company_match_iframe.scss": 881,
	"./pages/static_pages/completed_projects.scss": 882,
	"./pages/static_pages/css_docs.scss": 883,
	"./pages/static_pages/education.scss": 884,
	"./pages/static_pages/error.scss": 885,
	"./pages/static_pages/financials.scss": 886,
	"./pages/static_pages/fundraise.scss": 887,
	"./pages/static_pages/gala_dashboard.scss": 888,
	"./pages/static_pages/gift_guide.scss": 889,
	"./pages/static_pages/home.scss": 890,
	"./pages/static_pages/hundred_percent_model.scss": 891,
	"./pages/static_pages/in_kind_donations.scss": 892,
	"./pages/static_pages/internships.scss": 893,
	"./pages/static_pages/jobs.scss": 894,
	"./pages/static_pages/kids.scss": 895,
	"./pages/static_pages/local_partners.scss": 896,
	"./pages/static_pages/media.scss": 897,
	"./pages/static_pages/mission.scss": 898,
	"./pages/static_pages/our_approach.scss": 899,
	"./pages/static_pages/our_work.scss": 900,
	"./pages/static_pages/privacy.scss": 901,
	"./pages/static_pages/scott_harrison_story.scss": 902,
	"./pages/static_pages/scotts_story.scss": 903,
	"./pages/static_pages/sensors.scss": 904,
	"./pages/static_pages/staff.scss": 905,
	"./pages/static_pages/the_pool.scss": 906,
	"./pages/static_pages/volunteer.scss": 907,
	"./pages/static_pages/whywater.scss": 908,
	"./pages/subscriptions.scss": 909,
	"./pages/the_spring_series.scss": 910,
	"./pages/thirst/thirst.scss": 911,
	"./pages/uk/about.scss": 912,
	"./pages/uk/partnerships.scss": 913,
	"./pages/uk/privacy.scss": 914,
	"./pages/uk/uk.scss": 915,
	"./pages/unpledge.scss": 916,
	"./pages/video_landing_page.scss": 917,
	"./pages/wwd/community.scss": 918,
	"./pages/wwd/discover.scss": 919,
	"./pages/wwd/explore.scss": 920,
	"./pages/wwd/profile.scss": 921,
	"./pages/wwd/shared.scss": 922,
	"./pages/wwd/welcome.scss": 923,
	"./patterns/action-tiles.scss": 924,
	"./patterns/avatar-initial.scss": 925,
	"./patterns/cards.scss": 926,
	"./patterns/cw-icon-spin.scss": 927,
	"./patterns/dashed-button.scss": 928,
	"./patterns/full-bottom-bg.scss": 929,
	"./patterns/image-fill.scss": 930,
	"./patterns/module.scss": 931,
	"./patterns/progress.scss": 932,
	"./patterns/side-by-side.scss": 933,
	"./patterns/tabs.scss": 934,
	"./patterns/text-separator.scss": 935,
	"./patterns/yellow-underlined.scss": 936,
	"./react-components/email-capture-modal.scss": 937,
	"./react-components/journey-player.scss": 938,
	"./react-components/mailing-list-intercept-modal.scss": 939,
	"./react-components/people-served-input.scss": 940,
	"./settings/_colors.scss": 941,
	"./settings/_general.scss": 942,
	"./settings/_media-queries.scss": 943,
	"./settings/_mixins.scss": 944,
	"./settings/_type.scss": 945,
	"./shared/acts-as-user.scss": 946,
	"./shared/breadcrumbs.scss": 947,
	"./shared/clipboard-button.scss": 948,
	"./shared/cookie_banner.scss": 949,
	"./shared/datepicker.scss": 950,
	"./shared/geosuggest.scss": 951,
	"./shared/grecaptcha.scss": 952,
	"./shared/hide-donate-links.scss": 953,
	"./shared/intl-tel-input.scss": 954,
	"./shared/mailing-list-form.scss": 955,
	"./shared/mailing-list-sign-up-button.scss": 956,
	"./shared/parsley.scss": 957,
	"./shared/percy.scss": 958,
	"./shared/public_campaign_card_details.scss": 959,
	"./shared/simple-form.scss": 960,
	"./shared/sly-quiz.scss": 961,
	"./shared/spring_logo_svg.scss": 962,
	"./shared/spring_mark_svg.scss": 963,
	"./shared/video-box-container.scss": 964,
	"./tailwinds.scss": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;